import {ExtraInfo} from "./../../models/ExtraInfo";
import {ExtraInfoOption} from "./../../models/ExtraInfoOption";

let pipesApi = {
    async get(token, companyId, params={}){
        let response = await window.axios.get('/api/extrafields', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data.map(pipe=>new ExtraInfo(pipe));
    },
    async getOptions(token, companyId, params={}){
        let response = await window.axios.get('/api/extrafields/options', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data.map(pipe=>new ExtraInfoOption(pipe));
    },

}

export default pipesApi;